import { shallowEqual, useSelector } from "react-redux"
import { AppState } from "../app-state"
import { UserState } from "./user-state";

export const useUserPortfolioTeamCodes = () => {
    const teamCodes = useSelector((state: AppState) => state.user.userTeamCodes,
        shallowEqual
    );
    return teamCodes 
};

export const useUserPortfolioUserCompanies = () => {
    const userCompanies = useSelector((state: AppState) => state.user.userCompanies,
        shallowEqual
    );
    return userCompanies 
};


export const useInvalidOTL = () => {
    const errorOTL = useSelector((state: AppState) => state.user.invalidOTL,
        shallowEqual
    );
    return errorOTL || false
};

export const useUserLogOut = () => {
    const logoutUser = useSelector((state: AppState) => state.user.userLogOut,
        shallowEqual
    );
    return logoutUser || false
};

export const useUserAuthenticated = () => {
    const userAuthenticated = useSelector((state: AppState) => state.user.userAuthenticated, shallowEqual)
    return userAuthenticated || false
}

export const useUserInactivelyLoggedOut = () => {
    const userInactivelyLoggedOut = useSelector(
        (state: AppState) => state.user.userInactivelyLoggedOut,
        shallowEqual
    );
    return userInactivelyLoggedOut || false;
};

export const useUser = (): UserState => {
    const user = useSelector((state: AppState) => state.user, shallowEqual)
    return user || ({} as AppState['user']);
}

export const useLegalDisclaimerAccepted = () => {
    const legalDisclaimerAccepted = useSelector(
        (state: AppState) => state.user.legalDisclaimerAccepted,
        shallowEqual
    );
    return legalDisclaimerAccepted || false;
};
